(() => {
  if (window.__tathaScrollReveal) return;

  const state = {
    observerDefault: null,
    observerCards: null,
    selector: '[data-scroll-reveal], .scroll-reveal',
    pendingUntilLoader: document.documentElement.classList.contains('home-loader-active'),
  };

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const makeVisible = (element) => {
    element.classList.add('is-visible');
  };

  const createObserver = (options) => {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) return null;

    return new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        makeVisible(entry.target);
        observer.unobserve(entry.target);
      });
    }, options);
  };

  /* Default: subtle reveal as block enters frame. */
  const defaultObserverOptions = {
    root: null,
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.16,
  };

  /* Product collection cards should reveal a bit earlier. */
  const cardObserverOptions = {
    root: null,
    rootMargin: '0px 0px 50% 0px',
    threshold: 0.01,
  };

  const observe = (root = document) => {
    const elements = root.querySelectorAll(state.selector);
    if (!elements.length) return;

    elements.forEach((element) => {
      if (element.classList.contains('is-visible')) return;

      if (prefersReducedMotion || !state.observerDefault) {
        makeVisible(element);
        return;
      }

      /* Parallax “you are in the right hands” cards: section script reveals when ~half in view. */
      if (element.matches('[data-parallax-card]') && element.closest('.parallax-section')) {
        return;
      }

      if (element.classList.contains('collection-overlay-card') && state.observerCards) {
        state.observerCards.observe(element);
        return;
      }

      state.observerDefault.observe(element);
    });
  };

  const initialize = () => {
    state.observerDefault = createObserver(defaultObserverOptions);
    state.observerCards = createObserver(cardObserverOptions);
    if (!state.pendingUntilLoader) {
      observe(document);
    }
  };

  const onSectionLoad = (event) => {
    observe(event.target || document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:reorder', () => observe(document));
  document.addEventListener('homeLoader:complete', () => {
    state.pendingUntilLoader = false;
    observe(document);
  });

  window.__tathaScrollReveal = {
    refresh: () => observe(document),
  };
})();
